<template>
    <div>
        <b-modal
            size="xl"
            centered
            hide-footer
            title="Informações do produto"
            header-bg-variant="orange"
            header-text-variant="light"
            v-model="open"
        >
        <b-row>
            <b-col cols="5" class="slideImg">
                <b-col cols="5">
                    <div>
                        <b-img
                        :src="linkImage(product.image)"
                        width="300"
                        height="200"
                        :alt="product.image"
                        ></b-img>
                    </div>
                </b-col>
            </b-col>
            <div class="col-5 mb-4">
                <label>Produto:</label>
                <input
                type="text"
                disabled
                :value="product.name"
                class="form-control"
                >
                <label>Descrição:</label>
                <textarea
                type="text"
                :value="product.descricao"
                class="form-control"
                rows="3"
                readonly
                ></textarea>
            </div>
        <b-row>
            <div class="col-12">
                <label>Marca:</label>
                <input
                type="text"
                disabled
                :value="product.marca"
                class="form-control"
                >
                <label>Cod. barras:</label>
                <input
                type="text"
                disabled
                :value="product.barCode"
                class="form-control"
                >
                <label>Dimensões:</label>
                <input
                type="text"
                disabled
                :value="product.dimensoes"
                class="form-control"
                >
            </div>
        </b-row>
        </b-row>
        </b-modal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            open: false,
            product: [],
            detalhesP: [],
        }
    },

    methods: {
        toggleOpen({
            product
        }) {
            console.log('Produto', product);
            this.open = !this.open;
            this.product = product
        },

        linkImage(value) {
            return process.env.VUE_APP_FOTOS_URL + value;
        }
    }
}
</script>
<style scoped>
.infoProd {
    margin-left: 900%;
}
</style>